export interface CepResult {
    cep: string;
    logradouro: string;
    complemento: string;
    bairro: string;
    localidade: string;
    uf: string;
    erro?: boolean;
}

export const lookupCep = async (cep: string): Promise<CepResult | null> => {
    const cleanCep = cep.replace(/\D/g, '');
    if (cleanCep.length !== 8) return null;
    try {
        const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
        const data: CepResult = await response.json();
        if (data.erro) return null;
        return data;
    } catch (e) {
        console.error('CEP lookup error:', e);
        return null;
    }
};
